import './AuthorAvatar.scss';
import { ReactNode } from 'react';
import { getAuthorAvatar } from './author-avatar-utils';

interface AuthorAvatarProps {
  displayName: string | null | undefined;
  email: string;
}

export const AuthorAvatar = ({ displayName, email }: AuthorAvatarProps): ReactNode => {
  const { initials, backgroundColor } = getAuthorAvatar(displayName, email);
  return (
    <div className='author-avatar' style={{ backgroundColor }} aria-hidden='true'>
      {initials}
    </div>
  );
};
